/**
 * The message to show the user for a failed request.
 *
 * Prefers what the API said over what axios says: on a 500 the axios message is
 * "Request failed with status code 500", while the body carries the actual reason.
 * Falls back to the axios message, then to a generic wording, so the caller never
 * ends up concatenating `undefined` into a toast.
 */
export const errorMessage = (error: unknown): string => {
  const apiMessage = (error as any)?.response?.data?.message;
  if (typeof apiMessage === "string" && apiMessage.trim()) {
    return apiMessage;
  }

  const axiosMessage = (error as any)?.message;
  if (typeof axiosMessage === "string" && axiosMessage.trim()) {
    return axiosMessage;
  }

  return "erreur inconnue";
};
